<template>
  <div id="app">
    <ModalError />
    <component :is="layout">
      <router-view />
    </component>
   
  </div>
</template>

<script>
import ModalError from '@clir/Modal/ModalError';

const defaultLayout = "Default";

export default {
  name: 'CLIR',
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + "-layout";
    },
  },
  components: {
    ModalError,
  }
};
</script>